/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* eslint-disable lines-between-class-members */

/*
 * Enumeration of payment dialog states
 */

const PaymentDialogState = Object.freeze({
  INITIALIZING: {
    state: 'initializing',
    title: 'payment.result.redirecting.title',
    description: 'payment.result.redirecting.description',
    hasCheckCircleIcon: false,
    hasCancelIcon: false,
    hasWarningIcon: false,
  },
  PROCESSING: {
    state: 'processing',
    title: 'payment.result.processing.title',
    description: 'payment.result.processing.description',
    hasCheckCircleIcon: false,
    hasCancelIcon: false,
    hasWarningIcon: false,
  },
  PAYMENT_SUCCESS: {
    state: 'payment_success',
    title: 'payment.result.success.title',
    description: 'payment.result.success.description',
    hasCheckCircleIcon: true,
    hasCancelIcon: false,
    hasWarningIcon: false,
  },
  PRE_PAYMENT_FAILED: {
    state: 'pre_payment_failed',
    title: 'payment.prepayment.failed.title',
    description: 'payment.result.failed.description',
    hasCheckCircleIcon: false,
    hasCancelIcon: true,
    hasWarningIcon: false,
  },
  PAYMENT_FAILED: {
    state: 'payment_failed',
    title: 'payment.result.failed.title',
    description: 'payment.result.failed.description',
    hasCheckCircleIcon: false,
    hasCancelIcon: true,
    hasWarningIcon: false,
  },
  PAYMENT_TIMEOUT: {
    state: 'payment_timeout',
    title: 'payment.result.payment.timeout.title',
    description: 'payment.result.timeout.description',
    hasCheckCircleIcon: false,
    hasCancelIcon: true,
    hasWarningIcon: false,
  },
  CHANGE_PAYMENT_INTENT: {
    state: 'change_payment_intent',
    title: 'payment.result.change-payment-intent.title',
    description: 'payment.result.change-payment-intent.description',
    hasCheckCircleIcon: false,
    hasCancelIcon: false,
    hasWarningIcon: true,
  },
  CHANGE_PAYMENT_INTENT_SUCCESS: {
    state: 'change_payment_intent_success',
    title: 'payment.result.change-payment-intent-success.title',
    description: 'payment.result.change-payment-intent-success.description',
    hasCheckCircleIcon: true,
    hasCancelIcon: false,
    hasWarningIcon: false,
  },
  RETRY: {
    state: 'retrying',
    title: 'payment.result.success.title',
    description: 'payment.result.redirecting.description',
    hasCheckCircleIcon: false,
    hasCancelIcon: false,
    hasWarningIcon: false,
  },
});

export default PaymentDialogState;
